import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import BookApply from '@/types/table/bookApply';
import { BookData } from '@/api/generated/bookController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface BookApplyData extends BookApply {
  bookList?: BookData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class BookApplyController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<BookApplyData>>(
      API_CONTEXT + '/upms/bookApply/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<BookApplyData>(API_CONTEXT + '/upms/bookApply/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/bookApply/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/bookApply/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/bookApply/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/deleteBatch', params, httpOptions);
  }
  static startOnlyBookApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/startOnly/bookApplyFlow', params, httpOptions);
  }
  static startWithBusinessKeyBookApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/bookApply/startWithBusinessKey/bookApplyFlow',
      params,
      httpOptions,
    );
  }
  static startAndTakeUserTaskBookApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/bookApply/startAndTakeUserTask/bookApplyFlow',
      params,
      httpOptions,
    );
  }
  static startAndSaveDraftBookApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/bookApply/startAndSaveDraft/bookApplyFlow',
      params,
      httpOptions,
    );
  }
  static submitUserTaskBookApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/bookApply/submitUserTask/bookApplyFlow',
      params,
      httpOptions,
    );
  }
  static viewTaskBusinessDataBookApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(
      API_CONTEXT + '/upms/bookApply/viewTaskBusinessData/bookApplyFlow',
      params,
      httpOptions,
    );
  }
  static viewHistoricTaskBusinessDataBookApplyFlow(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.get(
      API_CONTEXT + '/upms/bookApply/viewHistoricTaskBusinessData/bookApplyFlow',
      params,
      httpOptions,
    );
  }
  static listWorkOrderBookApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/bookApply/listWorkOrder/bookApplyFlow',
      params,
      httpOptions,
    );
  }
  static viewNotInBookApplyRelList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/bookApply/viewNotInBookApplyRelList/bookApplyFlow',
      params,
      httpOptions,
    );
  }
  static listBookApplyRel(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/listBookApplyRel', params, httpOptions);
  }
  static listNotInBookApplyRel(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/listNotInBookApplyRel', params, httpOptions);
  }
  static addBookApplyRel(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/addBookApplyRel', params, httpOptions);
  }
  static deleteBookApplyRel(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/deleteBookApplyRel', params, httpOptions);
  }
  static deleteBookApplyRelList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/deleteBookApplyRelList', params, httpOptions);
  }
  static updateBookApplyRel(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/bookApply/updateBookApplyRel', params, httpOptions);
  }
  static viewBookApplyRel(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/bookApply/viewBookApplyRel', params, httpOptions);
  }
}
